export interface TranscriptTurn {
  id: string;
  role: 'agent' | 'user';
  text: string;
}

export function mergeTurnText(existing: string, incoming: string): string {
  const left = (existing || '').trim();
  const right = (incoming || '').trim();
  if (!left) return right;
  if (!right) return left;
  if (right.startsWith(left)) return right;
  if (left.startsWith(right)) return left;
  if (right.toLowerCase().includes(left.toLowerCase())) return right;
  if (left.toLowerCase().includes(right.toLowerCase())) return left;
  return `${left} ${right}`;
}

export function appendTranscriptTurn(
  turns: TranscriptTurn[],
  role: 'agent' | 'user',
  text: string
): TranscriptTurn[] {
  const trimmed = text?.trim();
  if (!trimmed) return turns;

  const last = turns[turns.length - 1];
  if (last && last.role === role) {
    const merged = mergeTurnText(last.text, trimmed);
    if (merged === last.text) {
      return turns;
    }
    return [
      ...turns.slice(0, -1),
      { ...last, text: merged },
    ];
  }

  return [
    ...turns,
    {
      id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      role,
      text: trimmed,
    },
  ];
}

export function collapseConsecutiveMessages<T extends { sender: 'ai' | 'user'; text: string }>(
  messages: T[]
): T[] {
  const collapsed: T[] = [];
  for (const message of messages) {
    const last = collapsed[collapsed.length - 1];
    if (last && last.sender === message.sender) {
      const merged = mergeTurnText(last.text, message.text);
      collapsed[collapsed.length - 1] = { ...last, text: merged };
    } else {
      collapsed.push({ ...message });
    }
  }
  return collapsed;
}
